<div [formGroup]="form" class="mb-3">
  <div>
    <input type="checkbox"
           class="form-check-input"
           id="reisedaten.letzteVisumStickernummer"
           formControlName="letzteVisumStickernummer"
           [ngbPopover]="popover_reisedaten_letzteVisumStickernummer"
           appSaveLastFocussed
    >
    <label for="reisedaten.letzteVisumStickernummer" [class.mandatory]="isMandatory('letzteVisumStickernummer')">
      <ng-container *ngIf="appConfig.umgebung === 'VIDEX'" i18n>Nummer der Visummarke, falls bekannt:</ng-container>
      <ng-container *ngIf="appConfig.umgebung === 'MEK'" i18n>Nummer des letzten Schengen-Visums:</ng-container>
    </label>
    <ng-template #popover_reisedaten_letzteVisumStickernummer>
      <app-assistant (assistantDisabled)="disableAssistant()">
        <span i18n>Bitte tragen Sie hier die Nummer Ihres letzten Schengen-Visums ein.</span>
      </app-assistant>
    </ng-template>
  </div>
  <div class="row" *ngIf="form.value.letzteVisumStickernummer === true">
    <div class="col-md-4">
      <select id="reisedaten.letzteVisumStickernummer.schengenLaendercode"
              class="form-select form-select-sm"
              [class.is-invalid]="errorClassRequired(form.controls['letzteVisumStickernummerSchengenLaendercode'])"
              formControlName="letzteVisumStickernummerSchengenLaendercode"
              [ngbPopover]="popover_reisedaten_letzteVisumStickernummer_schengenLaendercode"
              appSaveLastFocussed
      >
        <ng-template #popover_reisedaten_letzteVisumStickernummer_schengenLaendercode>
          <app-assistant (assistantDisabled)="disableAssistant()">
            <span i18n>Bitte wählen Sie hier die Buchstabenkombination aus, die der Nummer Ihres letzten Visums vorangestellt sind.</span>
          </app-assistant>
        </ng-template>
        <option value="" selected></option>
        <option *ngFor="let listItem of schengenlaendercodeListItems"
                value="{{ listItem.key }}">{{ listItem.value }}
        </option>
      </select>
    </div>
    <div class="col-md-8">
      <input id="reisedaten.letzteVisumStickernummer.nummer"
             type="text"
             appToUpperCase
             [attr.maxlength]="getMaxLength('nummer')"
             class="form-control form-control-sm"
             [class.is-invalid]="errorClassRequired(form.controls['letzteVisumStickernummerNummer'])"
             formControlName="letzteVisumStickernummerNummer"
             [ngbPopover]="popover_reisedaten_letzteVisumStickernummer_nummer"
             appSaveLastFocussed
      >
      <ng-template #popover_reisedaten_letzteVisumStickernummer_nummer>
        <app-assistant (assistantDisabled)="disableAssistant()">
          <span i18n>Bitte tragen Sie hier die Nummer Ihres letzten Visums ein.</span>
        </app-assistant>
      </ng-template>
    </div>
  </div>
</div>

